"use client";

import "./style.css";
import Helper from "../../util/helper";
import { Row, Col, Popover } from "antd";
import { useEffect, useState } from "react";
import formatMsg from "../../util/formatMsg";
import colors from "../../libs/colorFactory";
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import LinkWrapper from "../linkWrapper/page";
import { getIllumineProfileRows } from "../accountProfile/profileFields";
import { hasPermissionForEntity, PERMISSIONS } from "../../util/permissions";


const UserCard: React.FC<any> = (props) => {

    const {
        user,
        currentDetailedViewOfAccountId,
        firebase,
        accounts,
        action,
        getPopContent,
        getHeaderRedirectUrl,
        canEditUserInCurrentAccount,
        deleteUserConfirmation,
        getUserCardLabel,
        getUserCardValue,
        getAccountName,
        getAccountEmail,
        getAccountPhoneNumber,
        getAccountLinkStatus,
        showPopoverActions,
        isPrimaryAccount
    } = props;

    const [fields, setFields] = useState([]);
    const [showLinkedAccounts, setShowLinkedAccounts] = useState(false);
    const [showPop, setShowPop] = useState(false);
    const [additionalFieldMap, setAdditionalFieldMap] = useState(new Map());

    useEffect(() => {
        // Grid shows ONLY the student's own fields (their configured custom fields). Name + status
        // live in the header instead (status as a badge), so they aren't repeated as plain cells.
        let fieldsToRender: string[] = [];
        const additionalFieldMap = new Map();
        if (user?.childConfig) {
            user.childConfig.forEach((customFieldObj) => {
                fieldsToRender.push(customFieldObj.id);
                additionalFieldMap.set(customFieldObj.id, customFieldObj);
            });
        }
        setAdditionalFieldMap(additionalFieldMap);
        setFields(fieldsToRender);
    }, [user]);

    return (
        <div className='user-card-container'>
            <div className="user-card-header" style={{ borderBottom: "0.5px solid #E0E0E0" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <img className='user-profileIcon' src={Helper.getProfileImageUrl(user)} style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover" }} />
                    {
                        (Helper.getLoggedInUserType(firebase) === 'TEACHER') ?
                            <LinkWrapper href={getHeaderRedirectUrl(user)}>
                                <div className="custom-user-card-heading">{user.name}</div>
                            </LinkWrapper>
                            :
                            <div className="custom-user-card-heading">{user.name}</div>
                    }
                    {user.status && (
                        <span style={{ padding: "2px 10px", borderRadius: 999, fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", background: user.status === "ACTIVE" ? "#E9F7F0" : "#F0EEF3", color: user.status === "ACTIVE" ? "#1F9D6B" : "#6B6580", border: `1px solid ${user.status === "ACTIVE" ? "#BFE7D4" : "#E0E0E0"}` }}>
                            {formatMsg(user.status)}
                        </span>
                    )}
                    {user.migratedFromIllumine && (
                        <div className="illumine-tag">{formatMsg("illumine")}</div>
                    )}
                </div>
                {canEditUserInCurrentAccount(user) ?
                    <div>
                        {!user.migratedFromIllumine && hasPermissionForEntity(
                            firebase,
                            PERMISSIONS.PARTICIPANT_EDIT,
                            user.centerIds || []
                        ) && (
                                <img src="/images/newEditImg.png" className="user-in-account-edit"
                                    onClick={() => action(user)}
                                ></img>
                            )}
                        {!user.migratedFromIllumine && !Helper.isAccount(firebase) && hasPermissionForEntity(
                            firebase,
                            PERMISSIONS.PARTICIPANT_DELETE,
                            user.centerIds || []
                        ) && (
                                <img src="/images/newDeleteIcon.png" className="user-in-account-delete"
                                    onClick={() => deleteUserConfirmation(user)}
                                ></img>
                            )}
                    </div>
                    :
                    null
                }
            </div>

            <div className="user-main-card">
                <div className='user-details-rows'>
                    <Row style={{ padding: 8 }}>
                        {
                            user?.migratedFromIllumine
                                ? getIllumineProfileRows(user).map((field) => (
                                    <Col key={field.key} lg={5} md={5} sm={5} xs={5} className="user-field-style">
                                        <div className="user-label-container">
                                            <div>
                                                <div className="user-card-label-style user-text-wrap">{field.label}</div>
                                                <div className="user-card-value-style user-text-wrap">{field.value}</div>
                                            </div>
                                        </div>
                                    </Col>
                                ))
                                : null
                        }
                        {
                            fields?.map((item) => {
                                return (
                                    <Col lg={5} md={5} sm={5} xs={5} className="user-field-style">
                                        {
                                            !Helper.isAccount(firebase) ?
                                                <LinkWrapper href={"/dashboard/users/userDetailView?id=" + user.id + "&entityType=user"}>
                                                    <div className="user-label-container">
                                                        {item === "name" &&
                                                            <div className="account-name-column">
                                                                <img className='user-profileIcon' src={Helper.getProfileImageUrl(user)}></img>
                                                            </div>
                                                        }
                                                        <div>
                                                            <div className="user-card-label-style user-text-wrap">
                                                                {getUserCardLabel(item, additionalFieldMap)}
                                                            </div>
                                                            <div className="user-card-value-style user-text-wrap">
                                                                {getUserCardValue(item, user, additionalFieldMap)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </LinkWrapper>
                                                :
                                                <div className="user-label-container">
                                                    {item === "name" &&
                                                        <div className="account-name-column">
                                                            <img className='user-profileIcon' src={Helper.getProfileImageUrl(user)}></img>
                                                        </div>
                                                    }
                                                    <div>
                                                        <div className="user-card-label-style">
                                                            {getUserCardLabel(item, additionalFieldMap)}
                                                        </div>
                                                        <div className="user-card-value-style">
                                                            {getUserCardValue(item, user, additionalFieldMap)}
                                                        </div>
                                                    </div>
                                                </div>
                                        }
                                    </Col>
                                )
                            })
                        }
                    </Row>
                    {
                        showLinkedAccounts &&
                        <div>
                            <Row className="user-linked-accounts-header">
                                <Col lg={5} md={5} sm={5} xs={5} className="user-linked-accounts-style">
                                    {formatMsg("linkedAccounts")}
                                </Col>
                                <Col lg={5} md={5} sm={5} xs={5} className="user-linked-accounts-style">
                                    {formatMsg("email")}
                                </Col>
                                <Col lg={5} md={5} sm={5} xs={5} className="user-linked-accounts-style">
                                    {formatMsg("phoneNumber")}
                                </Col>
                                <Col lg={5} md={5} sm={5} xs={5} className="user-linked-accounts-style">
                                    {formatMsg("status")}
                                </Col>
                            </Row>
                            {user?.linkedAccountsIdAndStatusObjArr
                                ?.map(({ accountId, linkStatus, accountType }) => {
                                    let accountObj = accounts?.find((item) => item.id === accountId);
                                    if (accountObj) {
                                        return (
                                            <Row className="user-linked-account-row">
                                                <Col lg={5} md={5} sm={5} xs={5} className="user-linked-accounts-style">
                                                    <div className="account-name-column">
                                                        <img className='account-profileIcon' src={Helper.getProfileImageUrl(accountObj)}></img>
                                                        <div className="title-container">
                                                            <div className="global-subheader-regular">{getAccountName(accountObj)}</div>
                                                            {isPrimaryAccount(accountType)}
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col lg={5} md={5} sm={5} xs={5} className="user-linked-accounts-style">
                                                    {getAccountEmail(accountObj)}
                                                </Col>
                                                <Col lg={5} md={5} sm={5} xs={5} className="user-linked-accounts-style">
                                                    {getAccountPhoneNumber(accountObj)}
                                                </Col>
                                                <Col lg={5} md={5} sm={5} xs={5} className="user-linked-accounts-style">
                                                    {getAccountLinkStatus(linkStatus)}
                                                </Col>
                                                {
                                                    showPopoverActions(accountType)
                                                        ? (<Col>
                                                            <div className="pop-content-column">
                                                                <Popover
                                                                    open={showPop}
                                                                    onOpenChange={setShowPop}
                                                                    content={getPopContent(accountObj, user, linkStatus)}
                                                                    trigger='click'
                                                                    placement='bottomRight'
                                                                    id='custom-pop-over-style'
                                                                >
                                                                    <div
                                                                        className='three-dots-div'
                                                                    >
                                                                        <img
                                                                            className='three-dots'
                                                                            src='/images/threeDots.png'
                                                                        />
                                                                    </div>
                                                                </Popover>
                                                            </div>
                                                        </Col>)
                                                        : null
                                                }
                                            </Row>
                                        )
                                    }

                                })}
                        </div>
                    }
                </div>

                <Row className="user-hideshow-linked-accounts"
                    style={{ color: colors.v2_Cerulean }}
                    onClick={() => setShowLinkedAccounts(!showLinkedAccounts)}>
                    {showLinkedAccounts ? formatMsg("hideLinkedAccounts") : formatMsg("viewLinkedAccounts")}
                    {showLinkedAccounts ?
                        <UpOutlined
                            style={{ marginLeft: 10, marginTop: 3 }}
                        /> :
                        <DownOutlined
                            style={{ marginLeft: 10, marginTop: 3 }}
                        />}
                </Row>
            </div>
        </div>

    )
}
export default UserCard;